import { loopUrl } from '../config/api';

export default function cloudPageUrl(path) {
  return loopUrl + '/cloud/' + path;
}
